import { withI18n } from 'panda-i18n';
import { CnDownload as CnDownloadView } from './download';
import locale from '@/locales';
import './index.scss';
var CnDownload = withI18n(CnDownloadView, {
    locale: locale,
    componentName: 'CnDownload',
});
export { CnDownload };
